import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

// Legacy size chips ({size_name, in_stock}) — moved verbatim from PartnerMatchesPage.js.
// The Buyer Insights tab has its own SizeStatusChips (four states, as-of-End tooltips).
const SizeChips = ({ sizes, label }) => {
  if (!sizes || sizes.length === 0) {
    return <Typography variant="caption" color="text.secondary">No sizes</Typography>;
  }

  return (
    <Box>
      {label && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
          {label}
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {sizes.map((s) => (
          <Chip
            key={s.size_name}
            label={s.size_name}
            size="small"
            color={s.in_stock ? 'success' : 'default'}
            variant={s.in_stock ? 'filled' : 'outlined'}
            sx={{ fontSize: '0.75rem' }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default SizeChips;
